export class UploadDocsApiService {
    constructor(http) {
      this.endpoint = '/upload/template/';
      this.http = http;
    }
    async upload(file) { console.log(file);
      const headers = { 'Content-Type': 'multipart/form-data' };
      const { data } = await this.http.instance.post(this.endpoint, file, {
        headers
      });
      return data.template_url;
    }
  }
  